import { configureStore, getDefaultMiddleware } from "@reduxjs/toolkit";
import modalSlicer from "./slicers/modalSlicer";
import visitedProfileSlicer from "./slicers/visitedProfileSlicer";
import postSlicer from "./slicers/postSlicer";
import chatSlicer from "./slicers/chatSlicer";
import currentProfileSlicer from "./slicers/currentProfileSlicer";
import friendModalSlicer from "./slicers/friendModalSlicer";
import forgotPassswordSlicer from "./slicers/forgotPasswordSlicer";
import usersSlicer from "./slicers/usersSlicer";
import canadaNowSlicer from "./slicers/canadaNowSlicer";

export default configureStore({
  reducer: {
    visitedProfile: visitedProfileSlicer,
    currentProfile: currentProfileSlicer,
    modal: modalSlicer,
    friendModal: friendModalSlicer,
    post: postSlicer,
    chat: chatSlicer,
    forgotPassword: forgotPassswordSlicer,
    users: usersSlicer,
    canadaNow: canadaNowSlicer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({ serializableCheck: false }),
});

